import styled from 'styled-components';
import { Alert, Drawer } from 'antd';

export const StyledCheckBox = styled.div`
  width: 100%;

  .ant-checkbox-wrapper {
    width: 100%;

    .ant-checkbox-wrapper-in-form-item {
      margin-inline-end: 0;
    }
  }

  .ant-checkbox + span {
    padding-inline-start: 8px;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    max-height: calc(1.4em * 2); /* 2 lines with line-height 1.4 */
  }
`;

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-header-title {
    flex-direction: row-reverse;
    align-items: baseline;
  }

  .ant-drawer-body {
    padding: 0;
  }

  .ant-menu-light {
    background: unset;
  }
`;

export const StyledTitleHeader = styled.div`
  display: flex;
  margin: 10px 20px;
  align-items: center;
  justify-content: space-between;

  h3 {
    margin: 0;
  }
`;

export const MetricDivider = styled.div`
  height: 1px;
  background: #979797;
  opacity: 0.5;
  margin-bottom: 5px;
  width: 96%;
`;

export const CheckBoxList = styled.div`
  border: 1px transparent solid;
  width: 100%;
  padding-left: 8px;
`;

export const RowWrapper = styled.div`
  display: flex;
  margin-bottom: 10px;
`;

export const StyledText = styled.div`
  padding: 2px 0;
  font-size: 1.1rem;
  font-weight: 600;
  display: flex;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  overflow: hidden;

  .ant-menu-light.ant-menu-root.ant-menu-vertical {
    border-inline-end: none;
    border: none;
  }
`;

export const RightPanel = styled.div`
  flex: 1;
  overflow-y: auto;
  margin-left: 10px;
`;

export const CheckboxWrapper = styled.div<{ count: number }>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 16px;
  padding: 8px 0;
  align-items: start;
`;

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const FlexFill = styled.div`
  flex: 1;
`;

export const StyledNoFlow = styled.div`
  display: flex;
  padding: 20px;
`;

export const CountText = styled.div`
  margin: 0 10px;
  line-height: 2;
`;

export const StyledHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 20px;

  .ant-input-search-button {
    pointer-events: none;
  }
`;

export const CategoryWrapper = styled.div`
  width: 96%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;

  .activate-button {
    font-size: 16px;
    color: rgb(0 0 0 / 45%);

    &:hover {
      color: #0046ff;
    }
  }

  .create-button {
    height: 20px;
    padding: 0 4px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: #e6edff;
    color: #0046ff;
    font-size: 12px;
    border: none;
    border-radius: 2px;
  }
`;

export const ModelWrapper = styled.div`
  font-size: 18;
  color: gray;
  margin: 20px 10px 12px;
`;

export const AnchorWrapper = styled.div`
  background-color: #f6f6f6;
  width: 250px;
  height: 100%;
  overflow-y: auto;

  b {
    font-weight: 500;
  }
`;

export const StyledAlert = styled(Alert)`
  margin: 10px 20px 10px 10px;
`;
